import { Component, Input, OnInit } from '@angular/core';
import { tipoEntidadGeneral, entidadGeneral } from '../models/entidadGeneral';
import { SessionService } from '../services/session.service';

@Component({
  selector: 'nav-tabs',
  templateUrl: './nav-tabs.component.html',
  styleUrls: ['./nav-tabs.component.scss']
})
export class NavTabsComponent implements OnInit {
  ver = false;
  selected = 1;
  classTab = "tab-item";
  classLink = this.classTab + ' tab-enlace';
  @Input() tipoEG: any = tipoEntidadGeneral;

  Objeto = Object;
  constructor(private session: SessionService) {}

  ngOnInit(): void {
  }
  chooseMe(opt: number) {
    this.selected = opt;
    this.dropMenu();
  }
  abrir(enlace: string) {
    window.open(enlace, '_blank', 'noopener');
  }
  dropMenu() {
    let items = document.getElementsByClassName(this.classTab);
    for (let index = 0; index < items.length; index++) {
      let e = items.item(index);
      if (this.ver) {
        e?.classList.remove('ver');
      } else {
        e?.classList.add('ver');
      }
    }
    this.ver = !this.ver;
  }

}
